import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  MDTCVLRS: {},
  UNIDADXX: {},
  VALCAMPX: {},
  checkedRows: {},
};
const dosptefaSlice = createSlice({
  name: "dosptefa",
  initialState,
  reducers: {
    setMDTCVLRS: (state, action) => {
      const { value, index, CONCOBID } = action.payload;
      state.MDTCVLRS = { ...state.MDTCVLRS, [CONCOBID]: { ...state.MDTCVLRS[CONCOBID], [index]: value } };
    },
    setUNIDADXX: (state, action) => {
      const { value, index, CONCOBID } = action.payload;
      state.UNIDADXX = { ...state.UNIDADXX, [CONCOBID]: { ...state.UNIDADXX[CONCOBID], [index]: value } };
    },
    setVALCAMPX: (state, action) => {
      const { value, index, CONCOBID } = action.payload;
      state.VALCAMPX = { ...state.VALCAMPX, [CONCOBID]: { ...state.VALCAMPX[CONCOBID], [index]: value } };
    },
    setMassiveMDTCVLRS: (state, action) => {
      const { value, DOS, CONCOBID } = action.payload;
      let dataDo = {};
      DOS.forEach((DOCNROXX) => {
        dataDo[DOCNROXX] = value;
      });
      state.MDTCVLRS = { ...state.MDTCVLRS, [CONCOBID]: { ...state.MDTCVLRS[CONCOBID], ...dataDo } };
    },
    setMassiveUNIDADXX: (state, action) => {
      const { value, DOS, CONCOBID } = action.payload;

      let dataDo = {};
      DOS.forEach((DOCNROXX) => {
        dataDo[DOCNROXX] = value;
      });

      state.UNIDADXX = {
        ...state.UNIDADXX,
        [CONCOBID]: {
          ...(state.UNIDADXX[CONCOBID] || {}),
          ...dataDo,
        },
      };
    },
    setMassiveVALCAMPX: (state, action) => {
      const { value, DOS, CONCOBID } = action.payload;

      let dataDo = {};
      DOS.forEach((DOCNROXX) => {
        dataDo[DOCNROXX] = value;
      });

      state.VALCAMPX = {
        ...state.VALCAMPX,
        [CONCOBID]: {
          ...(state.VALCAMPX[CONCOBID] || {}),
          ...dataDo,
        },
      };
    },
    setCheckedRows: (state, action) => {
      const { values, CONCOBID } = action.payload;
      state.checkedRows = { ...state.checkedRows, [CONCOBID]: values };
    },
    resetValuesDosptefa: (state) => initialState,
  },
});
export const { setMDTCVLRS, setUNIDADXX, setVALCAMPX, setCheckedRows, setMassiveMDTCVLRS, setMassiveUNIDADXX, setMassiveVALCAMPX, resetValuesDosptefa } = dosptefaSlice.actions;
export default dosptefaSlice.reducer;

export const getMDTCVLRS = (state) => {
  return state.dosptefa.MDTCVLRS;
};

export const getUNIDADXX = (state) => {
  return state.dosptefa.UNIDADXX;
};

export const getVALCAMPX = (state) => {
  return state.dosptefa.VALCAMPX;
};

export const getCheckedRows = (state) => {
  return state.dosptefa.checkedRows;
};
